<template>
<span>
  <p><span style="font-size:10pt">Inhalt der Leistung:</span></p>

  <ul>
    <li>
      <p><span style="font-size:10pt">Vorstellung der angefertigten Planung nach Abschluss der Ausarbeitung</span></p>
    </li>
    <li>
      <p><span style="font-size:10pt">&Uuml;berpr&uuml;fung der eingeplanten Blitzschutzma&szlig;nahmen mit den Vor-Ort vorherrschenden Bedingungen,</span></p>
    </li>
    <li>
      <p><span style="font-size:10pt">Sowie Kl&auml;rung der m&ouml;glichen Umsetzung der Blitzschutzma&szlig;nahmen</span></p>
    </li>
  </ul>

  <p><span style="font-size:9pt"><em>Hinweis: Das Planungsabschlussgespr&auml;ch wird nur bei von uns geplanten Blitzschutzsystemen durchgef&uuml;hrt.</em></span></p>

</span>
</template>

<script>
export default {
  name: "TooltipPlanungsabschlussgespraech"
}
</script>

<style scoped>

</style>
